import { StyleSheet } from "aphrodite/no-important";

export const styles = StyleSheet.create({
  spacer: {
    height: 10
  }
});
